module.exports = __webpack_public_path__ + "static/media/hhv.4bc32095.png";